export default class Swipe {
  constructor(onSwipe, onMove = null) {
    this.x = null;
    this.y = null;
    this.onSwipe = onSwipe;
    this.onMove = onMove;
  }

  subscribe() {
    document.addEventListener('touchstart', e => this.start(e), false);
    document.addEventListener('touchmove', e => this.move(e), false);
    document.addEventListener('touchend', e => this.end(e), false);
  }

  unsubscribe() {
    document.removeEventListener('touchstart', e => this.start(e));
    document.removeEventListener('touchmove', e => this.move(e));
    document.removeEventListener('touchend', e => this.end(e));
  }

  start(e) {
    this.x = e.touches[0].clientX;
    this.y = e.touches[0].clientY;
  }

  move(e) {
    const dx = e.touches[0].clientX - this.x;
    const dy = e.touches[0].clientY - this.y;

    if (this.onMove) this.onMove(dx, dy);
  }

  end(e) {
    const dx = e.changedTouches[0].clientX - this.x;
    const dy = e.changedTouches[0].clientY - this.y;

    const adx = Math.abs(dx);
    const ady = Math.abs(dy);

    const { width, height } = window.screen;
    const reference = adx > ady ? width / 4 : height / 4;
    const results = adx > ady ? ['left', 'right'] : ['up', 'down'];
    const absDelta = adx > ady ? adx : ady;
    const delta = adx > ady ? dx : dy;

    if (absDelta > reference) {
      this.onSwipe(delta > 0 ? results[0] : results[1]);
    }

    if (this.onMove) {
      this.onMove(0, 0);
    }
  }
}
